import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { config } from './runtime-config';

Sentry.init({
  // Runtime first, and empty by default. A distributed on-prem image must not
  // carry a baked-in DSN: it would send a customer's errors to our Sentry from
  // inside their network, and on an air-gapped host it just fails noisily
  // (ERR_CERT_AUTHORITY_INVALID on every event). Operators opt in by setting
  // SENTRY_DSN on the web container.
  dsn: config('SENTRY_DSN', import.meta.env.VITE_SENTRY_DSN),
  environment: import.meta.env.MODE,

  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Tracing
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^\/api/],

  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true,
});
